import { render, staticRenderFns } from "./Compliant.vue?vue&type=template&id=99b79f9a"
import script from "./Compliant.vue?vue&type=script&lang=js"
export * from "./Compliant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports